import { ChangeDetectionStrategy, ChangeDetectorRef, Component, OnDestroy, OnInit } from '@angular/core';
import { Observable, Subscription } from 'rxjs';
import { NavigationCancel, Event, NavigationEnd, Router } from "@angular/router";
import { CheckoutStepService } from "@spartacus/checkout/base/components";
import { filter, map } from "rxjs/operators";
import { UserAccountFacade } from "@spartacus/user/account/root";
import { ActiveCartFacade, Cart } from '@spartacus/cart/base/root';
import { GenUserGroup } from 'src/app/generac/enums/user.enum';
import { SubscriptionsService } from 'src/app/generac/services/subscriptions.service';
import { GenCheckoutService } from 'src/app/generac/services/checkout.service';

@Component({
  selector: 'gen-cart-proceed-to-checkout',
  templateUrl: './cart-proceed-to-checkout.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
export class GenCartProceedToCheckoutComponent implements OnInit, OnDestroy {
  cartValidationInProgress = false;
  isButtonHidden$!: Observable<boolean>;
  protected subscription = new Subscription();

  constructor(
    protected router: Router,
    protected checkoutService: GenCheckoutService,
    protected cd?: ChangeDetectorRef,
    protected subscriptionsService?: SubscriptionsService,
    protected checkoutStepService?: CheckoutStepService,
    protected activeCartFacade?: ActiveCartFacade,
    protected userAccount?: UserAccountFacade,
  ) {
  }

  ngOnInit(): void {
    this.subscribeToRouterEvents();
    this.getUserAccount();
  }

  disableButtonWhileNavigation(): void {
    this.subscription.add(
      this.activeCartFacade.getActive().subscribe(cart => {
        this.cartValidationInProgress = true;
        this.checkoutStepService.resetSteps();
        this.checkoutService.disableCheckoutSteps(cart.cartTypes, cart.engineReplacement);
      })
    )
  }

  private subscribeToRouterEvents() {
    this.subscription.add(
      this.router.events
        .pipe(filter((event: Event) => event instanceof NavigationEnd || event instanceof NavigationCancel))
        .subscribe(() => {
          this.cartValidationInProgress = false;
          this.cd?.markForCheck();
        })
    );
  }

  private getUserAccount(): void {
    this.isButtonHidden$ = this.userAccount.get()
      .pipe(
        filter(user => !!user),
        map(user => !user?.roles?.includes(GenUserGroup.restrictedCheckoutGroup))
      );
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }
}
